module.exports = __webpack_public_path__ + "fonts/Roboto-Bold.583de8f.ttf";